import {
  Box,
  css,
  genesisStyled,
  StyleProps,
} from '@leagueplatform/genesis-commons';
import { MasonryCarouselRenderer } from '@leagueplatform/masonry-renderers';

const Container = genesisStyled(Box)<StyleProps>(({ listItemsCount, theme }) =>
  css({
    display: 'contents',
    '& ul > li': {
      ...(listItemsCount >= 2
        ? {
            maxWidth: '384px',
            minWidth: '384px',
            [`@media screen and (max-width: ${theme.breakpoints.phone})`]: {
              minWidth: '320px',
            },
          }
        : {}),
    },
  }),
);

type MasonryCarouselRendererProps = React.ComponentProps<
  typeof MasonryCarouselRenderer
>;

export const RewardProgramsCarousel = (props: MasonryCarouselRendererProps) => {
  const { items, ...rest } = props;

  return (
    <Container listItemsCount={items.length}>
      <MasonryCarouselRenderer
        items={items}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    </Container>
  );
};
